import React, { useEffect, useState } from 'react'

export const useIntersection = ({ ref, threshold=0.1, rootMargin="0px 0px 0px 0px" }) => {
  const [hasEnteredView, setHasEnteredView] = useState(false);
  
  useEffect(() => {
    const node = ref.current;
    if (!node || hasEnteredView) return;

    const reducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
    if (reducedMotion) {
      setHasEnteredView(true);
      return;
    }
    
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      setHasEnteredView(true);
      observer.disconnect();
    }, { threshold, rootMargin });

    observer.observe(node);

    return () => {
      observer.disconnect();
    };
  }, [hasEnteredView]);
  
  return {
    hasEnteredView, 
    setHasEnteredView
  }
}
